export default __webpack_public_path__ + "static/blob8-7785c644abf30e7b724ed57637318073.svg";